import React from 'react'

import ContentfulImageLink from '@src/quince-site-common/src/domains/contentful/ContentfulImageLink'
import ContentfulLink from '@src/quince-site-common/src/domains/contentful/ContentfulLink'
import ImageDomain from '@src/quince-site-common/src/domains/Image'

import { Link } from '..'
import { Image } from '../image'

export interface SocialBoxProps {
  footerSocial: ContentfulImageLink[]
}

const SocialBox = (props: SocialBoxProps) => {
  return (
    <div className="column-gap--2">
      {props.footerSocial.map(fs => {
        return (
          <Link href={ContentfulLink.getLinkPath(fs.link)} key={fs.link.text}>
            <Image
              url={ImageDomain.fromContentful(fs.images[0]).url}
              title={fs.images[0]?.title ?? ''}
              useNative
              alt=""
              width={24}
              height={24}
            />
          </Link>
        )
      })}
    </div>
  )
}

export default SocialBox
